(function () {
  angular.module("akitabox.ui.components.topBanner", []);
})();
